import { css } from 'lit';
import { CLOSE_ANIMATION_DURATION_IN_S } from './pimster-sticky-story-widget.constants';

export const pimsterStickyStoryWidgetStyle = css`
  .sticky-story-wrapper {
    position: fixed;
    z-index: 9999;
    opacity: 1;
    visibility: visible;
    transition-duration: ${CLOSE_ANIMATION_DURATION_IN_S}s;
    transition-property: all;
  }

  .sticky-story-wrapper.round {
    aspect-ratio: 1;
  }

  .sticky-story-wrapper.round.with-title {
    aspect-ratio: 12/16;
  }

  .sticky-story-wrapper.square {
    aspect-ratio: 9/16;
  }

  .iframe {
    border: none;
    height: 100%;
    width: 100%;
  }

  .close-button {
    position: absolute !important;
  }

  .close-button.round {
    top: calc(-12px + (2 * 0.7em)) !important;
    right: calc(-12px + (2 * 0.7em)) !important;
  }

  .close-button.square {
    top: -12px !important;
    right: -12px !important;
  }

  .sticky-story-wrapper.hidden {
    opacity: 0;
    visibility: hidden;
  }
`;
